<div class="user-panel mt-3 pb-3 mb-3 d-flex flex-column">
  <div class="d-flex justify-content-between">
    <div class="image">
      <img *ngIf="avatarImage" [src]="avatarImage" class="img-circle elevation-2" alt="User Image">
      <i *ngIf="!avatarImage" class="text-light fa-solid fa-3x fa-user"></i>
    </div>
    <div class="info mt-0 w-100 d-flex align-items-center">
      <a href="javascript:void(0)" class="d-block text-truncate">{{ name }}</a>
    </div>
    <div class="mx-1">
      <button class="btn bg-dark" type="button" data-toggle="collapse" data-target="#collapseShow" aria-expanded="false"
        aria-controls="collapseShow">
        <i class="bg-button fas fa-angle-down fa-xs"></i>
      </button>
    </div>
  </div>
  <div class="collapse" id="collapseShow">
    <div class="mt-2 col-4">
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column">
          <li class="nav-item">
            <a class="nav-link pointer" routerLink="/" (click)="userLogout()">
              <i class="nav-icon fas fa-sign-out-alt fa-lg"></i>
              <p>{{'@core.menu.logout' | translate}}</p>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link pointer" routerLink="/auth" fragment="resetpassword={{token}}" (click)="resetPassword()">
              <i class="nav-icon fas fa-sign-out-alt fa-lg"></i>
              <p>{{'@core.menu.resetPassword' | translate}}</p>
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>